import { RepoAsyncUpdateClient } from '@aas-dashboard/asyncapi/services/repo-async-update-client'
import { DEFAULT_BACKEND_WS_URL } from '@/constants'

export default new RepoAsyncUpdateClient({
  url: DEFAULT_BACKEND_WS_URL
})
